/**
 * Dados citados no artigo pilar — alinhados com a resposta autenticada de
 * GET /api/v1/internal/audit (keywordSuggestions; fonte gscQueries seed até JSON GSC).
 */
export const ESTUDO_CASO_AEO_AUDIT_QUERIES = [
  {
    queryPt: 'eeat google atualização conteúdo',
    queryEn: 'eeat google content update',
    impressions: 7400,
  },
  {
    queryPt: 'indexação spa react seo',
    queryEn: 'SPA React SEO indexing',
    impressions: 5600,
  },
  {
    queryPt: 'snippet otimização ctr sem mudar posição',
    queryEn: 'snippet CTR optimization without ranking change',
    impressions: 5100,
  },
] as const;

export const ESTUDO_CASO_TITLE_LEN_BEFORE = 78;
export const ESTUDO_CASO_TITLE_LEN_AFTER = 59;
export const ESTUDO_CASO_SUBSCRIBE_PATH = '/subscribe?plan=professional&payNow=1';

export const SLUG_PT = 'estudo-caso-aeo-7400-impressoes';
export const SLUG_EN = 'en-case-study-aeo-7400-impressions';
export const PATH_EN = '/en/blog/case-study-aeo-7400-impressions';
